import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Page from './Page';
import AboutUs from './AboutUs'; // Make sure this path matches your file structure
import './App.css';
import AutocompleteInput from './AutoCompleteInput';
import CategorySelector from './CategorySelector';
import Food from './Food';
import FoodDetail from './FoodDetail';
import IngredientForm from './IngredientForm';
import SearchBar from './SearchBar';
import PrivacyPolicy from './PrivacyPolicy';
import NutriLore from './NutriLore';
import NutrientTable from './NutrientTable';
import NeutriFacts from './NeutriFacts';

import Footer from './Footer';
import Therapy from './Theraphy';
import Breathing from './Breathing';
import ImmuneSystem from './ImmuneSystem';

function App() {
  return (
    <Router>
      <Routes>

{/* Page layout wraps both product views */}
        <Route path="/" element={<Page />}>
          <Route index element={<Food />} />           {/* Default view */}
          <Route path="Food" element={<Food />} />     {/* Ingredient Lore */}
          <Route path="NutriLore" element={<NutriLore />} /> {/* Nutrient Lore */}
          <Route path="Theraphy" element={<Therapy />} /> 
          <Route path="Breathing" element={<Breathing />} /> 
          <Route path="ImmuneSystem" element={<ImmuneSystem />} /> 

        

        
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/AutoCompleteinput" element={<AutocompleteInput />} />
        <Route path="/CategorySelector" element={<CategorySelector />} />
        <Route path="/Food" element={<Food />} />
        <Route path="/FoodDetail" element={<FoodDetail />} />
        <Route path="/IngredientForm" element={<IngredientForm />} />
        <Route path="/Page" element={<Page />} />
        <Route path="/SearchBar" element={<SearchBar />} />
         <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/NutriLore" element={<NutriLore />} />
           <Route path="/NutrientTable" element={<NutrientTable />} />
               <Route path="/NeutriFacts" element={<NeutriFacts />} />
           </Route>   
                 <Route path="/Footer" element={<Footer />} />
        

      </Routes>
    </Router>
  );
}

export default App;
